import { render } from "./RestorePasswordView.vue?vue&type=template&id=285f48fb"
import script from "./RestorePasswordView.vue?vue&type=script&lang=js"
export * from "./RestorePasswordView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__